import { Injectable } from "@angular/core";
import { Subject } from "rxjs/Subject";

@Injectable()
export class MessageService {
  private messageSource = new Subject<Object>();
  message$ = this.messageSource.asObservable();

  constructor() { }

  setMesage(msg) {
    this.messageSource.next(msg);
  }
  success(msg: string, title?: string) {
    let tmp = { severity: "success", summary: (title || "成功"), detail: msg };
    this.messageSource.next(tmp);
  }
  warn(msg: string, title?: string) {

    let tmp = { severity: "warn", summary: (title || "警告"), detail: msg };
    this.messageSource.next(tmp);
  }
  info(msg: string, title?: string) {

    let tmp = { severity: "info", summary: (title || "消息"), detail: msg };
    this.messageSource.next(tmp);
  }
  error(msg: string, title?: string) {

    let tmp = { severity: "error", summary: (title || "错误"), detail: msg };
    this.messageSource.next(tmp);
  }
  clear() {
    this.messageSource.next(null);
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/core/services/message.service.ts